export const chaseHelpTextData = [
    {
        id: "driversLicenseSummary",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "Both sides of your licence, ensuring all corners are visible and not cropped out.",
            "Format": "Take a photo now or upload an image.",
            "Tips": "Ensure clear visibility and readability of all information. Good lighting and a flat surface help avoid shadows and glare."
        }
    }, {
        id: "licenseScan",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": " Both sides of your licence, ensuring all corners are visible and not cropped out.",
            "Format": "Take a photo now or upload an image.",
            "Tips": "Ensure clear visibility and readability of all information. Good lighting and a flat surface help avoid shadows and glare."
        }
    }, {
        id: "disclosedClaims",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "Why we need it": "The ‘Claims Underwriting Exchange’ has identified a claim(s) in your name that wasn’t disclosed when you purchased the policy. Failing to include all previous claims on your policy can invalidate your cover in the event of a claim.",
            "What we need": "An email or documentation from you previous broker or insurer, stating all previous claims they have on file for you.",
            "How to obtain it": "Contact your previous insurer and ask for your claims history to be sent over to you.",
            "Format": " Any format, such as a document or screenshot of an email trail.",
            "Tips": "Failure to provide this document will result in the undisclosed claim(s) being added to your policy, which may increase the premium."
        }
    },
    {
        id: "ncbScan",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "Document stating your years of no claims from your previous broker or insurer. Must include insurer's name and dates you were covered.",
            "How to obtain it": "Contact your previous insurer if you don’t have this document. They can provide a statement or letter confirming your NCB.",
            "Format": "Take a photo or upload the document.",
            "Tips": "Failure to provide this document will result in your No Claims Bonus being changed to 0 years, which may impact your premium."
        }
    }, {
        id: "v5cScan",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "The section of the V5C showing the vehicle's make, model, and registered keeper.",
            "Where to find it": "This is typically stored with your vehicle documentation or important household paperwork.",
            "Format": "Capture a photo or upload an image of the document.",
            "Tips": "Document should be flat and fully in frame for clear visibility"
        }
    }, {
        id: "bankStatement",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "A bank statement showing transactions, clearly displaying your name and address, dated within the last 3 months.",
            "How to obtain it": "If not readily available, you can download recent statements via your bank’s online portal or request a mailed copy.",
            "Format": "Take a photo or upload a photo or scanned copy.",
            "Tips": "Ensure dates and transaction details are legible and the dates are visible."
        }
    }, {
        id: "proofOfAddress",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "A utility bill, bank statement, or government-issued letter showing your name and address, dated within the last three months.",
            "Format": "Take a photo now or upload an image or scanned copy.",
            "Tips": "Ensure the entire document is visible and details are readable. Flatten out any creases for clarity."
        }
    }, {
        id: "odoMeterReading",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "A photo showing your vehicle’s current mileage. Where to find it: Located on the dashboard behind the steering wheel.",
            "Format": "Snap a photo with your camera.",
            "Tips": "Make sure the reading is the focus, with no reflections obscuring the numbers."
        }
    }, {
        id: "mirroredNcbProof",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "A document showing you have a No Claims Bonus on another vehicle that you wish to mirror onto this policy.",
            "How to obtain it": "Request from your insurer if not in possession. Explain the need to mirror this bonus onto another vehicle.",
            "Format": "You can either upload an image/document or take a picture.",
            "Tips": "Ensure the document clearly states the vehicle and policyholder details, along with the NCB years being mirrored."
        }
    }, {
        id: "photosOfVan",
        note: "Allow multiple/unlimited uploads, and on click of button provide three options: Camera, Files, Gallery",
        helpText: {
            "What to include": "Clear images showing all sides of the vehicle’s exterior and detailed shots of the interior.",
            "Format": "You can take new photos or upload existing ones.",
            "Tips": "Good lighting is crucial. Aim for daylight shots to capture the van's condition accurately. Cover different angles to give a complete overview.",
        }
    }
]